<template>
  <div class="card" style="margin-top: -55px;">
    <div class="card-header" style="display: flex;flex-direction: row;">
      <div style="margin-right: 50px;"><h4 class="card-title">Detail information for last month activities</h4></div>
    </div>
    <div class="card-body">
      <div class="table-responsive" style="overflow: auto">
        <table class="table tablesorter" style="overflow: hidden">
          <thead class=" text-primary">
          <tr>
            <th>
              Date
            </th>
            <th>
              Start
            </th>
            <th>
              End
            </th>
            <th class="text-center">
              Hours
            </th>
            <th class="text-center">
              Wage
            </th>
            <th class="text-center">
              Confirm
            </th>
            <th class="text-center">
              Paid
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in values" :key="index">
            <td>
              {{normalDate(item.date)}}
            </td>
            <td>
              {{timeToAmPm(item.time_start.split(" ")[1])}}
            </td>
            <td>
              {{item.time_end == null ? 'not finished':timeToAmPm(item.time_end.split(" ")[1])}}
            </td>
            <td class="text-center">
              {{difference(item.time_start,item.time_end)}}
            </td>
            <td class="text-center">
              {{formatter.format(countWage(item.time_start,item.time_end,item.rate))}}
            </td>
            <td class="text-center">
              {{item.is_confirm === '1' ? 'Yes':'No' }}
            </td>
            <td class="text-center">
              {{item.is_paid === '1' ? 'Yes':'No' }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import PerfectScrollbar from 'perfect-scrollbar';
    export default {
      props: ['values'],
      name: "clocks-values",
      data(){
        return{
          formatter:{},
          isMobile:false,
          ps: null,
        }
      },
      methods: {
        difference: function (start,end) {
          if (end === null){
            return 'not finished'
          }else{
            let date1 = new Date(start.split('-').join('/'));
            let date2 = new Date(end.split('-').join('/'));
            let dif = new Date(date2 - date1);
            return dif.getUTCHours()+':'+dif.getUTCMinutes()+':'+dif.getUTCSeconds();
          }
        },
        countWage: function(start,end,wage){
          if (end === null){
            return 0
          }else{
            let date1 = new Date(start.split('-').join('/'));
            let date2 = new Date(end.split('-').join('/'));
            let dif = new Date(date2 - date1);
            wage = parseInt(wage);
            return Math.floor(dif.getUTCHours()*wage + (dif.getUTCMinutes()*wage)/60 + (dif.getUTCSeconds()*wage)/3600);
          }
        },
        timeToAmPm:function(time){
          let timeValue = 0;
          if (time !== null){
            time = time.split(':');
            if (time.length === 3){
              let hours = Number(time[0]);
              let minutes = Number(time[1]);
              let seconds = Number(time[2]);

              if (hours > 0 && hours <= 12) {
                timeValue = hours;
              } else if (hours > 12) {
                timeValue = hours - 12;
              } else if (hours === 0) {
                timeValue = 12;
              }
              timeValue = (timeValue < 10) ? "0" + timeValue: timeValue;
              timeValue += (minutes < 10) ? ":0" + minutes : ":" + minutes;  // get minutes
              //timeValue += (seconds < 10) ? ":0" + seconds : ":" + seconds;  // get seconds
              timeValue += (hours >= 12) ? " p.m." : " a.m.";  // get AM/PM
            }
          }
          else{timeValue = "not finished"}
          return timeValue;
        },
        normalDate(date){
          date = new Date(date.split('-').join('/') + " ");
          return date.toLocaleDateString();
        }
      },
      mounted() {

      },
      created() {
        this.formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
        });
        this.isMobile = (/Mobile|Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent));
      },

    }
</script>

<style scoped>

</style>
